import { forwardRef } from 'react';
import { Link, type LinkProps } from 'react-router-dom';

import { Box, Flex, type BoxProps, type FlexProps } from '@frontend/components';

export const InteractiveBox = ({ onClick, children, ...props }: BoxProps) => (
  <Box
    cursor="pointer"
    bg="page.surface"
    _hover={{ background: 'interaction.surfaceHover' }}
    _active={{ background: 'interaction.surfaceActive' }}
    onClick={onClick}
    {...props}
  >
    {children}
  </Box>
);

export const InteractiveFlex = forwardRef<HTMLDivElement, FlexProps>(
  ({ onClick, children, ...props }, ref) => (
    <Flex
      cursor="pointer"
      bg="page.surface"
      _hover={{ background: 'interaction.surfaceHover' }}
      _active={{ background: 'interaction.surfaceActive' }}
      onClick={onClick}
      ref={ref}
      {...props}
    >
      {children}
    </Flex>
  ),
);

InteractiveFlex.displayName = 'InteractiveFlex';

type InteractiveAsLinkProps<T> = T & Pick<LinkProps, 'to'>;

export const InteractiveBoxAsLink = ({
  to,
  onClick,
  children,
  ...props
}: InteractiveAsLinkProps<BoxProps>) => (
  <Box
    cursor="pointer"
    as={Link}
    bg="page.surface"
    _hover={{ background: 'interaction.surfaceHover' }}
    _active={{ background: 'interaction.surfaceActive' }}
    to={to}
    onClick={onClick}
    {...props}
  >
    {children}
  </Box>
);

export const InteractiveFlexAsLink = ({
  to,
  onClick,
  children,
  ...props
}: InteractiveAsLinkProps<FlexProps>) => (
  <Flex
    cursor="pointer"
    as={Link}
    _hover={{ background: 'interaction.surfaceHover' }}
    _active={{ background: 'interaction.surfaceActive' }}
    to={to}
    onClick={onClick}
    borderRadius="inherit"
    {...props}
  >
    {children}
  </Flex>
);
